export default (study, extraData) => extraData?.displaySets?.map(ds => ds.SeriesDescription);
